var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.602,
    height: 21.581,
    viewBox: "0 0 21.602 21.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.066,
    y1: 0.049,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 21.602,
    height: 21.581,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M21.041,18.39a1.848,1.848,0,0,1,0,2.651,1.9,1.9,0,0,1-2.651,0L10.8,13.455,3.212,21.041a1.81,1.81,0,0,1-1.326.54,1.81,1.81,0,0,1-1.326-.54,1.848,1.848,0,0,1,0-2.651L8.147,10.8.561,3.212a1.848,1.848,0,0,1,0-2.651,1.848,1.848,0,0,1,2.651,0L10.8,8.147,18.39.561a1.848,1.848,0,0,1,2.651,0,1.848,1.848,0,0,1,0,2.651L13.455,10.8Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.6c1f90e3d175e033a975fcafcbff5feb.svg";
export { ForwardRef as ReactComponent };